module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.client.username))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('date')
      }
    }
  }, [_vm._v("Дата" + _vm._s(_vm.sortIcon('date')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumPay')
      }
    }
  }, [_vm._v("Сумма пополнено" + _vm._s(_vm.sortIcon('sumPay')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumConsume')
      }
    }
  }, [_vm._v("Сумма израсходовано" + _vm._s(_vm.sortIcon('sumConsume')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('author')
      }
    }
  }, [_vm._v("Автор" + _vm._s(_vm.sortIcon('author')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.sortedBillings), function(billing) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(billing.date) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(billing.sumPay) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(billing.sumConsume) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(billing.author) + "\n            ")]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), (_vm.canCreate(_vm.permissionKey)) ? _c('tr', [_c('td', [_c('datepicker', {
    attrs: {
      "placeholder": "Введите дату",
      "inputClass": {
        test: true
      },
      "config": {
        wrap: true,
        dateFormat: 'd.m.Y',
        locale: _vm.l10n
      },
      "readonly": ""
    },
    model: {
      value: (_vm.newbilling.date),
      callback: function($$v) {
        _vm.$set(_vm.newbilling, "date", $$v)
      },
      expression: "newbilling.date"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "data-clear": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])], 1), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbilling.sumPay),
      expression: "newbilling.sumPay"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите сумму оплаты"
    },
    domProps: {
      "value": (_vm.newbilling.sumPay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newbilling, "sumPay", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _c('td', [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Добавить оплату")])])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ИТОГО")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.sumPay))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.sumConsume))]), _vm._v(" "), _c('th', [_vm._v("ОСТАТОК")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.balance))])])], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n              Первая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n              Предыдущая\n            ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page.name) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n              Следующая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n              Последняя\n            ")])])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loggedId == _vm.$props.id) ? _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Оплатить на сумму")])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumPayment),
      expression: "sumPayment"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите сумму оплаты"
    },
    domProps: {
      "value": (_vm.sumPayment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sumPayment = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2095a2c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/billing/Billing.vue
// module id = 427
// module chunks = 40